import { APIService } from "@/services/api";
import { API } from "@/lib/api";
import { ReadCitizenship, WriteCitizenship } from "@/types/citizenship";

export const CitizenshipService = new APIService<
  ReadCitizenship,
  WriteCitizenship
>(API.Citizenships);
export const fetchCitizenshipList = CitizenshipService.getList;
export const fetchCitizenship = CitizenshipService.get;
export const createCitizenship = CitizenshipService.post;
export const updateCitizenship = CitizenshipService.patch;
